import { requestApi } from 'api/api'
import { BulkCapabilityRequest, BulkCapabilityResponse } from 'types/capabilities/capabilities'

export const getBulkCapabilityValues = (
  request: BulkCapabilityRequest
): Promise<BulkCapabilityResponse> => {
  return requestApi({
    url: '/v1/capabilities/bulk',
    method: 'POST',
    data: request,
  })
}
